/* eslint-disable no-nested-ternary */
import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";

import WordCloud from "../WordCloud";
import { Modal } from "../../../../../components/simple";
import SVG from "../../../../../components/SVG";

import wordCloudZoomIcon from "../../../../../assets/images/zoom-in.svg";

import styles from "./wordcloud-panel.module.scss";

const WordCloudPanel = ({ words, isLoading, type }) => {
  const [isShowWordCloudModal, setShowWordCloudModal] = useState(false);

  const fontSizes = useMemo(() => {
    return [
      (24 * window.screen.width) / 1920,
      (40 * window.screen.width) / 1920
    ];
  }, []);

  const handleWordCloudModalClose = () => {
    setShowWordCloudModal(false);
  };

  return (
    <>
      <div className={styles["audience-description-title"]}>Description</div>
      {words.length ? (
        <div
          className={`${styles["audience-description-word-cloud-container"]} ${
            isLoading ? styles["is-loading"] : ""
          }`}
          style={{
            height: type === "fullReport" ? "520px" : "380px",
            padding: type === "fullReport" ? "16px 24px" : "16px",
            marginBottom: type === "fullReport" ? 0 : "41px"
          }}
        >
          <WordCloud words={words} type={type} />
          <button
            className={styles["audience-description-word-cloud-zoom-button"]}
            type="button"
            onClick={() => {
              setShowWordCloudModal(true);
            }}
          >
            <img src={wordCloudZoomIcon} alt="zoom" />
          </button>
          <Modal
            className="screen-modal word-cloud-modal"
            isOpen={isShowWordCloudModal}
            // handleClose={handleWordCloudModalClose}
            toggle={handleWordCloudModalClose}
          >
            <WordCloud words={words} fontSizes={fontSizes} padding={8} />
            <SVG.Close
              className={`${styles["close-modal"]}`}
              onClick={handleWordCloudModalClose}
            />
          </Modal>
        </div>
      ) : (
        <div>No data to display</div>
      )}
    </>
  );
};

WordCloudPanel.propTypes = {
  words: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isLoading: PropTypes.bool,
  type: PropTypes.string.isRequired
};

WordCloudPanel.defaultProps = {
  isLoading: false
};

export default WordCloudPanel;
